// Component: src/theme/sections/usp.liquid

document.addEventListener('DOMContentLoaded', () => {
  const screenWidth = window.innerWidth;
  const uspBlocks = document.querySelectorAll('.section-usp-wrapper');

  if (uspBlocks.length > 0 && screenWidth < 768) {
    let toggle = false;
    setInterval(() => {
      uspBlocks.forEach((block) => {
        block.scrollTo({left: toggle ? 0 : screenWidth, behavior: 'smooth'});
        toggle = !toggle;
      });
    }, 4000)
  }
});
